import React, { useEffect, useState } from "react";
import api, { fmtErr } from "../../lib/api";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Users, KeyRound } from "lucide-react";
import { toast } from "sonner";

const RUOLI = { super_admin: "Super Admin", amministrazione: "Amministrazione", project_manager: "Project manager", sola_lettura: "Sola lettura", investitore: "Associato (portale)" };

export const UsersPanel = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/users").then((r) => setRows(r.data.filter((u) => u.role !== "investitore"))).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const reset = async (u) => {
    if (!window.confirm(`Inviare a ${u.email} il link per impostare una nuova password (valido 1 ora)?`)) return;
    try { const r = await api.post(`/users/${u.id}/reset-password`); toast.success(`Link inviato a ${r.data.email}`); if (r.data.link) { await navigator.clipboard?.writeText(r.data.link); toast.info("Anteprima: link copiato negli appunti"); } }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); }
  };
  return (
    <Card className="p-4 space-y-3" data-testid="users-panel">
      <div className="font-semibold flex items-center gap-2"><Users className="w-4 h-4" /> Utenti del gestionale</div>
      <p className="text-xs text-muted-foreground">La gestione completa (crea, ruoli, società, disattiva, permessi per ruolo) è in <a className="underline" href="/utenti">Impostazioni → Utenti e accessi</a>. Qui puoi inviare rapidamente un link per una nuova password.</p>
      {rows === null ? <div className="text-xs text-muted-foreground">Caricamento…</div> : (
        <div className="divide-y text-sm">
          {rows.map((u) => (
            <div key={u.id} className="flex items-center justify-between py-2 gap-2" data-testid="users-row">
              <div className="min-w-0"><div className="font-medium truncate">{u.name || u.email}</div><div className="text-xs text-muted-foreground truncate">{u.email}</div></div>
              <div className="flex items-center gap-2 shrink-0"><Badge variant="outline">{RUOLI[u.role] || u.role}</Badge>{u.active === false && <Badge variant="destructive">disattivo</Badge>}
                <Button variant="outline" size="sm" onClick={() => reset(u)} data-testid="users-reset-btn"><KeyRound className="w-3.5 h-3.5 mr-1" /> Invia link nuova password</Button></div>
            </div>))}
        </div>)}
    </Card>
  );
};
